import Repository from "../Repository";

const Create = "create";
const getChapterByCourseId = "getChapterByCourseId";
const GetSingle = "getSingleCourse";
const Delete = "deleteCourse";
const UPDATE_CHAPTER = "edit";
const DeleteChapter = "delete";

export default {
  CreateChapter(payload) {
    return Repository.post(transformRoute(Create), payload);
  },
  GetChapterByCourseId(payload) {
    return Repository.post(transformRoute(getChapterByCourseId), payload);
  },
  getSingleCourse(payload) {
    return Repository.post(transformRoute(GetSingle), payload);
  },
  deleteCourse(payload) {
    return Repository.post(transformRoute(Delete), payload);
  },
  updateChapter(payload) {
    return Repository.post(transformRoute(UPDATE_CHAPTER), payload);
  },
  deleteChapter(payload) {
    return Repository.post(transformRoute(DeleteChapter), payload);
  },
};

const transformRoute = (route) => {
  return `eLearning/chapter/${route}`;
};
